module.exports = __webpack_public_path__ + "img/icon-icn-edit-3.4d324121.svg";